import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useExclusiveOffer from 'hooks/useExclusiveOffer';
import useUtmsFromSession from 'hooks/useUtmsFromSession';
import useWishlist from 'hooks/useWishlist';

import { sendEvent } from 'lib/gtag';
import { toOfferRedirectLink } from 'lib/links';
import placeholder from 'lib/placeholder';

const FinishedOfferButtons = ({
  gaEventCategory,
  gaEventCategoryPostfix,
  mostRelevantKeyword,
  offerId = null,
  offerSlug,
  offerUserVisibility,
}) => {
  const { isOfferBlocked } = useExclusiveOffer();
  const { addOfferWishlistKeyword } = useWishlist(gaEventCategory, {
    gaEventLabel: 'wishlist_main_button',
  });
  const { utmParams } = useUtmsFromSession();

  const onWishlistButtonClick = () => {
    addOfferWishlistKeyword({ keywordDisplay: mostRelevantKeyword });
  };

  return (
    <div className="flex flex-col gap-2 lg:flex-row lg:gap-4">
      <Button
        as="a"
        className="border-none bg-neutral-high-400 dark:bg-neutral-high-400 lg:w-2/3"
        disabled={isOfferBlocked(offerUserVisibility, offerSlug)}
        href={toOfferRedirectLink(offerId, utmParams)}
        iconLeft={<Icon name="link-blank" />}
        size="size1"
        type="neutral"
        full
        onClick={() => {
          sendEvent({
            action: 'go_store',
            category: `${gaEventCategory}${
              gaEventCategoryPostfix ? `_${gaEventCategoryPostfix}` : ''
            }`,
          });
        }}
      >
        {placeholder('titles.finishedOffer')}
      </Button>
      <Button
        aria-label="Lista de desejos"
        className="lg:w-1/3"
        iconLeft={<Icon name="heart" />}
        size="size1"
        type="primary"
        full
        onClick={onWishlistButtonClick}
      >
        {placeholder('actions.activateAlert')}
      </Button>
    </div>
  );
};

FinishedOfferButtons.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  gaEventCategoryPostfix: PropTypes.string,
  mostRelevantKeyword: PropTypes.string.isRequired,
  offerCoupon: PropTypes.string,
  offerId: PropTypes.number,
  offerSlug: PropTypes.string.isRequired,
  offerUserVisibility: PropTypes.string.isRequired,
};

export default FinishedOfferButtons;
